export const LangType = Object.freeze({
  CN: 'cn',
  EN: 'En',
})
